import { i18n } from '@/i18n'
// icon 在这里
// https://element.eleme.cn/#/zh-CN/component/icon
export default [
  {
    title: i18n.t('menu.analytics'),
    icon: 'el-icon-s-home',
    route: { name: 'home' },
    can: []
  },
  {
    title: i18n.t('menu.request'),
    icon: 'el-icon-view',
    children: [
      {
        title: i18n.t('model.withdrawalApplication'),
        icon: 'el-icon-s-finance',
        route: { name: 'withdrawal_applications.index' }
      },
      {
        title: i18n.t('menu.userVerifications'),
        icon: 'el-icon-s-check',
        route: { name: 'user_verifications.index' },
        can: 'users.review',
      },
      {
        title: i18n.t('menu.newStoreOwner'),
        icon: 'el-icon-s-custom',
        route: { name: 'new_store_owners.index' },
        can: 'store_owners.read'
      },
      {
        title: i18n.t('model.resetPasswordApplication'),
        icon: 'el-icon-document',
        route: { name: 'reset_password_applications.index' }
      },
      {
        title: i18n.t('menu.electricity'),
        icon: 'el-icon-bangzhu',
        route: { name: 'user_request/electricities.index' },
        can: 'user_requests.read'
      },
      {
        title: i18n.t('menu.airtime'),
        icon: 'el-icon-phone',
        route: { name: 'user_request/airtimes.index' },
        can: 'user_requests.read'
      },
    ]
  },
  {
    title: i18n.t('menu.userManagement'),
    icon: 'el-icon-user',
    children: [
      {
        title: i18n.t('model.user'),
        icon: 'el-icon-s-custom',
        route: { name: 'users.index' }
      },
    ]
  },
  {
    title: i18n.t('menu.storeManagement'),
    icon: 'el-icon-s-shop',
    children: [
      {
        title: i18n.t('model.storeOwner'),
        icon: 'el-icon-s-custom',
        route: { name: 'store_owners.index' }
      },
      {
        title: i18n.t('model.merchant'),
        icon: 'el-icon-s-shop',
        route: { name: 'merchants.index' },
        can: ['merchants.read']
      },
      {
        title: i18n.t('model.agent'),
        icon: 'el-icon-user-solid',
        route: { name: 'agents.index' },
        can: ['agents.read']
      },
      {
        title: i18n.t('menu.merchantCatalog'),
        icon: 'el-icon-s-shop',
        route: { name: 'merchant_catalog.index' },
        can: 'merchants.read'
      },
      {
        title: i18n.t('menu.placesListing'),
        icon: 'el-icon-s-shop',
        route: { name: 'places_listing.index' },
        can: 'merchants.read'
      },
      {
        title: i18n.t('menu.exploreSection'),
        icon: 'el-icon-s-shop',
        route: { name: 'explore_section.index' },
        can: 'merchants.read'
      },
    ]
  },
  {
    title: i18n.t('menu.adSpace'),
    icon: 'el-icon-s-grid',
    route: { name: 'custom_lists.index', params: { menu_type: 'ad_space' } }
  },
  {
    title: i18n.t('menu.videoSpace'),
    icon: 'el-icon-s-grid',
    route: { name: 'custom_lists.index', params: { menu_type: 'video_space' } }
  },
  {
    title: i18n.t('menu.loyaltyPrograms'),
    icon: 'el-icon-money',
    children: [
      {
        title: i18n.t('model.event'),
        icon: 'el-icon-s-ticket',
        route: { name: 'events.index' }
      },
      {
        title: i18n.t('model.redPacket'),
        icon: 'el-icon-money',
        route: { name: 'red_packets.index' }
      },
      {
        title: i18n.t('menu.redPacketJoga'),
        icon: 'el-icon-money',
        route: { name: 'red_packet_joga.index' },
        can: 'red_packets.read'
      },
      {
        title: i18n.t('menu.redPacketSettings'),
        icon: 'el-icon-setting',
        route: { name: 'red_packet_settings.show' },
        can: 'settings.read'
      },
      {
        title: i18n.t('model.brand'),
        icon: 'el-icon-s-shop',
        route: { name: 'brands.index' }
      },
    ]
  },
  {
    title: i18n.t('menu.ledger'),
    icon: 'el-icon-s-order',
    children: [
      {
        title: i18n.t('menu.masterLedger'),
        icon: 'el-icon-s-order',
        can: [],
        route: { name: 'master_ledger' }
      },
    ]
  },
  {
    title: i18n.t('menu.transactions'),
    icon: 'el-icon-s-marketing',
    children: [
      {
        title: i18n.t('menu.allTransactions'),
        icon: 'el-icon-s-marketing',
        can: 'plutus_entries.read',
        route: { name: 'transaction_history.index' }
      },
      {
        title: 'P2P',
        icon: 'el-icon-s-custom',
        can: 'plutus_entries.read',
        route: { name: 'transaction_history_p2p.index' }
      },
      {
        title: 'P2M',
        icon: 'el-icon-s-shop',
        can: 'plutus_entries.read',
        route: { name: 'transaction_history_p2m.index' }
      },
      {
        title: i18n.t('menu.grab'),
        icon: 'el-icon-money',
        can: 'plutus_entries.read',
        route: { name: 'transaction_history_red_packet.index' }
      },
      {
        title: i18n.t('menu.cashback'),
        icon: 'el-icon-coin',
        can: 'plutus_entries.read',
        route: { name: 'transaction_history_cashback.index' }
      },
    ]
  },
  {
    title: i18n.t('menu.eventManagement'),
    icon: 'el-icon-s-ticket',
    children: [
      {
        title: i18n.t('menu.createEvent'),
        icon: 'el-icon-s-management',
        route: { name: 'ticket_events.index' }
      },
      {
        title: i18n.t('menu.addTickets'),
        icon: 'el-icon-s-ticket',
        route: { name: 'ticket_kinds.index' }
      },
      {
        title: i18n.t('model.actsAsTaggableOn/tag'),
        icon: 'el-icon-collection-tag',
        route: { name: 'acts_as_taggable_on/tags.index' },
        can: 'tags.read'
      },
      {
        title: i18n.t('menu.liveEvents'),
        icon: 'el-icon-s-order',
        route: { name: 'live_events.index' },
        can: 'ticket_events.read',
      },
      {
        title: i18n.t('menu.eventHistory'),
        icon: 'el-icon-tickets',
        route: { name: 'event_history.index' },
        can: 'ticket_events.read',
      },
      {
        title: i18n.t('model.ticketRedeemBatch'),
        icon: 'el-icon-view',
        route: { name: 'ticket_redeem_batches.index' }
      },
    ]
  },
  {
    title: i18n.t('menu.walk'),
    icon: 'el-icon-place',
    route: { name: 'walk_analytics' },
    can: []
  },
  {
    title: 'LeClub',
    icon: 'el-icon-place',
    children: [
      {
        title: i18n.t('model.walk/club'),
        icon: 'el-icon-s-shop',
        route: { name: 'walk/clubs.index' },
        can: 'walk_clubs.read'
      },
      {
        title: i18n.t('model.walk/prize'),
        icon: 'el-icon-medal',
        route: { name: 'walk/prizes.index' },
        can: 'walk_prizes.read'
      },
      {
        title: i18n.t('model.walk/challenge'),
        icon: 'el-icon-s-finance',
        route: { name: 'walk/challenges.index' },
        can: 'walk_challenges.read'
      },
      {
        title: i18n.t('model.walk/challengeParticipationRecord'),
        icon: 'el-icon-s-check',
        route: { name: 'walk/challenge_participation_records.index' },
        can: 'walk_challenge_participation_records.read'
      },
    ]
  },
  {
    title: 'Heba',
    icon: 'el-icon-place',
    children: [
      {
        title: i18n.t('model.walk/hebaRewardRuleItem'),
        icon: 'el-icon-medal',
        route: { name: 'walk/heba_reward_rule_items.index' },
        can: 'walk_heba_reward_rule_items.read'
      },
      {
        title: i18n.t('model.walk/hebaParticipationRecord'),
        icon: 'el-icon-s-check',
        route: { name: 'walk/heba_participation_records.index' },
        can: 'walk_heba_participation_records.read'
      },
    ]
  },
  // {
  //   title: i18n.t('menu.pageManagement'),
  //   icon: 'el-icon-s-management',
  //   children: [
  //     {
  //       title: i18n.t('model.customPage'),
  //       icon: 'el-icon-s-operation',
  //       route: { name: 'custom_pages.index' }
  //     },
  //   ]
  // },
  // {
  //   title: i18n.t('model.banner'),
  //   icon: 'el-icon-picture-outline',
  //   route: { name: 'banners.index' }
  // },
  {
    title: i18n.t('model.activeStorageBlob'),
    icon: 'el-icon-upload',
    route: { name: 'active_storage/blobs.index' },
    can: ['active_storage_blobs.read']
  },
  // {
  //   title: i18n.t('model.application'),
  //   icon: 'el-icon-menu',
  //   route: { name: 'applications.index' },
  //   can: ['applications.read_list_menu']
  // },
  // {
  //   title: i18n.t('model.application'),
  //   icon: 'el-icon-menu',
  //   route: { name: 'applications.show', params: { id: 'current' } },
  //   can: ['applications.read_detail_menu']
  // },
  {
    title: i18n.t('menu.dataAnalysis'),
    icon: 'el-icon-view',
    children: [
      {
        title: i18n.t('wechatMiniProgram.analysis.userPortrait'),
        icon: 'el-icon-s-custom',
        route: { name: 'user_portrait' },
        can: 'data_analyses.user_portrait'
      },
      {
        title: i18n.t('wechatMiniProgram.analysis.visitPage'),
        icon: 'el-icon-document-copy',
        route: { name: 'visit_page' },
        can: 'data_analyses.visit_page'
      },
      {
        title: i18n.t('wechatMiniProgram.analysis.visitDistribution'),
        icon: 'el-icon-pie-chart',
        route: { name: 'visit_distribution' },
        can: 'data_analyses.visit_distribution'
      },
      {
        title: i18n.t('wechatMiniProgram.analysis.visitRetain'),
        icon: 'el-icon-s-data',
        route: { name: 'retain_info' },
        can: 'data_analyses.retain_info'
      },
      {
        title: i18n.t('wechatMiniProgram.analysis.visitTrend'),
        icon: 'el-icon-data-line',
        route: { name: 'visit_trend' },
        can: 'data_analyses.visit_trend'
      }
    ]
  },
  {
    title: i18n.t('menu.notifications'),
    icon: 'el-icon-message-solid',
    children: [
      {
        title: i18n.t('menu.smsPush'),
        icon: 'el-icon-postcard',
        route: { name: 'sms.index' },
        can: 'users.push_notifications'
      },
      {
        title: i18n.t('menu.clientAppPush'),
        icon: 'el-icon-mobile',
        route: { name: 'client_app_push.index' },
        can: 'users.push_notifications'
      },
      {
        title: i18n.t('menu.agentAppPush'),
        icon: 'el-icon-mobile-phone',
        route: { name: 'agent_app_push.index' },
        can: 'agents.push_notifications'
      },
      {
        title: i18n.t('model.pushNotificationHistory'),
        icon: 'el-icon-view',
        route: { name: 'push_notification_histories.index' }
      },
    ]
  },
  // 以下代码为generator插入代码的标记，请勿修改或删除
  // Generator menu
  {
    title: i18n.t('model.feedback'),
    icon: 'el-icon-warning',
    route: { name: 'feedbacks.index' }
  },
  // {
  //   title: i18n.t('model.hotWord'),
  //   icon: 'el-icon-view',
  //   route: { name: 'hot_words.index' }
  // },
  {
    title: i18n.t('model.setting'),
    icon: 'el-icon-view',
    children: [
      {
        title: i18n.t('model.page'),
        icon: 'el-icon-edit-outline',
        route: { name: 'pages.index' }
      },
      {
        title: i18n.t('menu.rulesAndKycs'),
        icon: 'el-icon-view',
        route: { name: 'settings.show' },
      },
      {
        title: i18n.t('menu.appVersionSettings'),
        icon: 'el-icon-view',
        route: { name: 'app_version_settings.show' },
        can: 'settings.read'
      },
      {
        title: i18n.t('menu.specificVerificationCodes'),
        icon: 'el-icon-setting',
        route: { name: 'specific_verification_codes.show' },
        can: 'settings.read'
      },
      {
        title: i18n.t('model.adminUsersRole'),
        icon: 'el-icon-user-solid',
        route: { name: 'admin_users_roles.index' }
      },
      {
        title: i18n.t('model.role'),
        icon: 'el-icon-view',
        route: { name: 'roles.index' }
      },
    ]
  },
];
